import { LIST_QUERY_CACHE_TTL_SECONDS, PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { getMockProjectFilterOptions } from './mockProjects';
import { mockDelay } from './mockUtils';

/** Visibility is a fixed set, so only the owners and teams come from the data. */
export interface GetProjectFilterOptionsResponse {
  owners: string[];
  teams: string[];
}

const MOCK_RESPONSE_DELAY_MS = 200;

const getProjectFilterOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProjectFilterOptions: builder.query<GetProjectFilterOptionsResponse, void>({
      // The backend has no projects endpoints yet: serve mock data (see mockProjects.ts).
      queryFn: async (_args, { getState }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        return { data: getMockProjectFilterOptions(getState()) };
      },
      providesTags: [{ type: PROJECTS_LIST_TAG, id: 'filter-options' }],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetProjectFilterOptionsQuery } = getProjectFilterOptionsApi;
